import * as React from "react";

import { Confirm, Status } from "./Chapters";

export default ({ key, method }) => {
  switch (key) {
    case "STATUS":
      return <Status {...{ method }} />;
    default:
      return <Confirm {...{ method }} />;
  }
};
